<template>
    <el-row class="footer">
        <el-row class="first">
            <el-col :span="7" class="item">
            </el-col>
            <el-col :span="2" class="item pointer" @click.native="toPage('/news')">
                新闻中心
            </el-col>
            <el-col :span="2" class="item pointer" @click.native="toPage('/business')">
                业务聚焦
            </el-col>
            <el-col :span="2" class="item pointer" @click.native="toPage('/about')">
                关于我们
            </el-col>
            <el-col :span="2" class="item pointer" @click.native="toPage('/welfare')">
                公益事业
            </el-col>
            <el-col :span="2" class="item pointer" @click.native="toPage('/jobs')">
                人才招聘
            </el-col>
            <el-col :span="7" class="item pointer">
            </el-col>
        </el-row>
        <el-row class="second">
            <el-col :span="7">
                <el-row>
                    <img src="../assets/imgs/logo-2.png" style="width: 100%;height: auto;" />
                </el-row>
                <!--<el-row class="footer-row">-->
                <!--长春市三合通科技有限责任公司-->
                <!--</el-row>-->
                <el-row class="footer-row">
                    <el-col :span="4">地址:</el-col>
                    <el-col :span="18">长春市净月开发区净月影视文化创意产业园5号楼A区6层</el-col>
                </el-row>
                <el-row class="footer-row">
                    <el-col :span="4">电话:</el-col>
                    <el-col :span="18">19944841741</el-col>
                </el-row>
                <el-row class="footer-row">
                    <el-col :span="4">邮箱:</el-col>
                    <el-col :span="18">wuy@ccsht.cn</el-col>
                </el-row>
                <el-row class="footer-row">
                    <el-col :span="4">备案号:</el-col>
                    <el-col :span="18"><span class="pointer" @click="recordClick">吉ICP备2020004345号-1</span></el-col>
                </el-row>
            </el-col>

            <el-col :span="2" class="item"></el-col>

            <el-col :span="2">
                <el-row class="footer-row pointer" @click.native="toPage('/business')">业务介绍</el-row>
                <el-row class="footer-row pointer" @click.native="toPage('/business')">解决方案</el-row>
            </el-col>
            <el-col :span="2">
                <el-row class="footer-row pointer" @click.native="toPage('/about')">
                    公司简介
                </el-row>
                <el-row class="footer-row pointer" @click.native="toPage('/about')">
                    董事长致辞
                </el-row>
                <el-row class="footer-row pointer" @click.native="toPage('/about')">
                    愿景与文化
                </el-row>
            </el-col>

            <el-col :span="2" class="item"></el-col>
            <el-col :span="2" class="item"></el-col>

            <el-col :span="7">
                <el-row class="text-center footer-row">
                    <img style="width: 150px; height: 150px;" src="../assets/imgs/footer/qrcode.jpg" />
                </el-row>
                <el-row class="text-center">
                    <img style="width: 40px;height: 40px;" src="../assets/imgs/footer/wx.png" />
                </el-row>
            </el-col>
        </el-row>

    </el-row>
</template>

<script>
    export default {
        name: "Footer",
        methods: {
            toPage (path) {
                this.$router.push({
                    path: path
                });
            },
            recordClick () {
                window.open('https://beian.miit.gov.cn', 'target');
            }
        }
    }
</script>

<style scoped>
.footer {
    height: 400px;
    width: 100%;
    color: #777777;
    text-align: left;
    background: #262626;
}

.first {
    width: 100%;
    height: 60px;
    color: #a8a8a8;
    background: #1b1b1b;
    padding: 0 8%;
}

.item {
    height: 60px;
    line-height: 60px;
}

.text-right {
    text-align: right;
}

.text-center {
    text-align: center;
}

.footer-row {
    margin-bottom: 10px;
}

.second {
    padding: 1% 8%;
}

.pointer {
    cursor: pointer;
}

.pointer:hover {
    color: #ffffff;
}
</style>
